import { Input } from 'antd';
import { ReactElement, ReactNode } from 'react';

import FormItemWithLabel from '../../../components/Form/FormItemWithLabel';
import { DocumentInvoiceEntity, InvoiceDetail } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import InvoiceDetailForm from '../Invoice/InvoiceDetailForm';
import { InvoiceTable } from '../Invoice/InvoiceTable';
import TransferDestinationForm from '../Invoice/TransferDestinationForm';
import renderTableColumn from './renderTableColumn';
import { OcrResultPageDefinition, ResultPageDocument } from './types';

type Props = {
  entity: DocumentInvoiceEntity;
};
function InvoiceFormInputs({ entity }: Props): ReactElement {
  return (
    <>
      <FormItemWithLabel label="請求日">
        <Input disabled defaultValue={entity.invoice_date} />
      </FormItemWithLabel>
      <FormItemWithLabel label="請求元事業者名">
        <Input disabled defaultValue={entity.biller_company_name} />
      </FormItemWithLabel>
      <FormItemWithLabel label="請求元事業者番号">
        <Input disabled defaultValue={entity.biller_company_number} />
      </FormItemWithLabel>
      <FormItemWithLabel label="請求先事業者名">
        <Input disabled defaultValue={entity.billing_company_name} />
      </FormItemWithLabel>
      <TransferDestinationForm transferDestinations={entity.transfer_destinations ?? []} />
      <InvoiceDetailForm entity={entity} />
    </>
  );
}
export function buildInvoiceDetail(entity: DocumentInvoiceEntity): InvoiceDetail {
  const initialTaxPercent = entity.tax?.[0]?.percent ?? 0;
  const initialTaxAmount = entity.tax?.[0]?.amount ?? 0;
  const initialAmountWithTax = entity.total_invoice_amount ?? 0;
  const initialAmountWithoutTax = initialAmountWithTax == 0 ? 0 : initialAmountWithTax - initialTaxAmount;
  const initialAccount = entity.invoice_details?.[0]?.account ?? '';
  const initialAccountCode = entity.invoice_details?.[0]?.account_code ?? '';
  return {
    tax_percent: initialTaxPercent,
    amount_without_tax: initialAmountWithoutTax,
    tax_amount: initialTaxAmount,
    amount_with_tax: initialAmountWithTax,
    account: initialAccount,
    account_code: initialAccountCode,
  };
}

function expandInvoiceTable(record: ResultPageDocument<DocumentInvoiceEntity>): ReactNode {
  if (record.error) {
    return;
  }
  const initialDetail = buildInvoiceDetail(record.latest_revision);
  const invoiceDetails =
    record.latest_revision.invoice_details && record.latest_revision.invoice_details.length > 0
      ? record.latest_revision.invoice_details
      : [initialDetail];
  return <InvoiceTable invoiceDetails={invoiceDetails} />;
}

const invoiceResultPageDefinition: OcrResultPageDefinition<DocumentInvoiceEntity> = {
  name: ocrTypeNameDefinitions.invoice,
  tableColumns: [
    { dataIndex: ['latest_revision', 'invoice_date'], title: '請求日', render: renderTableColumn },
    { dataIndex: ['latest_revision', 'biller_company_name'], title: '請求元事業者名', render: renderTableColumn },
    {
      dataIndex: ['latest_revision', 'biller_company_number'],
      title: '請求元事業者番号',
      render: renderTableColumn,
    },
    { dataIndex: ['latest_revision', 'billing_company_name'], title: '請求先事業者名', render: renderTableColumn },
  ],
  tableExpandable: {
    expandedRowRender: expandInvoiceTable,
  },
  formComponent: InvoiceFormInputs,
};

export default invoiceResultPageDefinition;
